import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitActivity } from "./pit-activity";
import { PitActivityFinancingAmount } from "./pit-activity-financing-amount";
import { PitActivityStateProgramIndicators } from "./pit-activity-state-program-indicators";
import { PitFile } from "../../pit-shared/domain/pit-file";
import { PitFinancingRedistribution } from "./pit-financing-redistribution";
import { PitFinancingRedistributionLite } from "./pit-financing-redistribution-lite";
import { PitActivityFinancingAmountBySource } from "./pit-activity-financing-amount-by-source";
import { DxObjectMapper } from "../../dx-core/services/dx-object-mapper.service";
/** Версия мероприятия */
let PitActivityVersion = class PitActivityVersion {
    /** Версия мероприятия */
    constructor() {
        /** Общие реквизиты мероприятия */
        this._activity = new PitActivity();
        /** Финансирование по источникам */
        this._financingAmountBySource = [];
        /** Перераспределение по источникам */
        this._financingRedistribution = [];
        /** Массив прикрепленных файлов */
        this.files = [];
    }
    get financingRedistributionLight() {
        return this.financingRedistribution ?
            DxObjectMapper.deserializeASArray(DxObjectMapper.serializeASArray(this.financingRedistribution, PitFinancingRedistribution), PitFinancingRedistributionLite) : [];
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get code() {
        return this._code;
    }
    set code(value) {
        this._code = value;
    }
    get activity() {
        return this._activity;
    }
    set activity(value) {
        this._activity = value;
    }
    get isActual() {
        return this._isActual;
    }
    set isActual(value) {
        this._isActual = value;
    }
    get actualDate() {
        return this._actualDate;
    }
    set actualDate(value) {
        this._actualDate = value;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(value) {
        this._isDeleted = value;
    }
    get funcCustomerId() {
        return this._funcCustomerId;
    }
    set funcCustomerId(value) {
        this._funcCustomerId = value;
    }
    get govCustomerId() {
        return this._govCustomerId;
    }
    set govCustomerId(value) {
        this._govCustomerId = value;
    }
    get stateProgramId() {
        return this._stateProgramId;
    }
    set stateProgramId(value) {
        this._stateProgramId = value;
    }
    get blockId() {
        return this._blockId;
    }
    set blockId(value) {
        this._blockId = value;
    }
    get subBlockId() {
        return this._subBlockId;
    }
    set subBlockId(value) {
        this._subBlockId = value;
    }
    get dopEkId() {
        return this._dopEkId;
    }
    set dopEkId(value) {
        this._dopEkId = value;
    }
    get kcsrId() {
        return this._kcsrId;
    }
    set kcsrId(value) {
        this._kcsrId = value;
    }
    get statusId() {
        return this._statusId;
    }
    set statusId(value) {
        this._statusId = value;
    }
    get purchaseStartPlanDate() {
        return this._purchaseStartPlanDate;
    }
    set purchaseStartPlanDate(value) {
        this._purchaseStartPlanDate = value;
    }
    get changeDate() {
        return this._changeDate;
    }
    set changeDate(value) {
        this._changeDate = value;
    }
    get changeUserFio() {
        return this._changeUserFio;
    }
    set changeUserFio(value) {
        this._changeUserFio = value;
    }
    get changeNotice() {
        return this._changeNotice;
    }
    set changeNotice(value) {
        this._changeNotice = value;
    }
    get financingAmount() {
        return this._financingAmount;
    }
    set financingAmount(value) {
        this._financingAmount = value;
    }
    get financingAmountBySource() {
        return this._financingAmountBySource;
    }
    set financingAmountBySource(value) {
        this._financingAmountBySource = value;
    }
    get stateProgramIndicators() {
        return this._stateProgramIndicators;
    }
    set stateProgramIndicators(value) {
        this._stateProgramIndicators = value;
    }
    get planTypeId() {
        return this._planTypeId;
    }
    set planTypeId(value) {
        this._planTypeId = value;
    }
    get budgetPeriod() {
        return this._budgetPeriod;
    }
    set budgetPeriod(value) {
        this._budgetPeriod = value;
    }
    get workTypeId() {
        return this._workTypeId;
    }
    set workTypeId(value) {
        this._workTypeId = value;
    }
    get totalAmount() {
        return this._totalAmount;
    }
    set totalAmount(value) {
        this._totalAmount = value;
    }
    get firstPeriodAmount() {
        return this._firstPeriodAmount;
    }
    set firstPeriodAmount(value) {
        this._firstPeriodAmount = value;
    }
    get secondPeriodAmount() {
        return this._secondPeriodAmount;
    }
    set secondPeriodAmount(value) {
        this._secondPeriodAmount = value;
    }
    get thirdPeriodAmount() {
        return this._thirdPeriodAmount;
    }
    set thirdPeriodAmount(value) {
        this._thirdPeriodAmount = value;
    }
    get totalRegionalAmount() {
        return this._totalRegionalAmount;
    }
    set totalRegionalAmount(value) {
        this._totalRegionalAmount = value;
    }
    get firstPeriodRegionalAmount() {
        return this._firstPeriodRegionalAmount;
    }
    set firstPeriodRegionalAmount(value) {
        this._firstPeriodRegionalAmount = value;
    }
    get secondPeriodRegionalAmount() {
        return this._secondPeriodRegionalAmount;
    }
    set secondPeriodRegionalAmount(value) {
        this._secondPeriodRegionalAmount = value;
    }
    get thirdPeriodRegionalAmount() {
        return this._thirdPeriodRegionalAmount;
    }
    set thirdPeriodRegionalAmount(value) {
        this._thirdPeriodRegionalAmount = value;
    }
    get financingRedistribution() {
        return this._financingRedistribution;
    }
    set financingRedistribution(value) {
        this._financingRedistribution = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "code", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityVersion.prototype, "_code", void 0);
tslib_1.__decorate([
    jsonMember({ name: "activity", constructor: PitActivity, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitActivity)
], PitActivityVersion.prototype, "_activity", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isActual", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitActivityVersion.prototype, "_isActual", void 0);
tslib_1.__decorate([
    jsonMember({ name: "actualDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitActivityVersion.prototype, "_actualDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isDeleted", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitActivityVersion.prototype, "_isDeleted", void 0);
tslib_1.__decorate([
    jsonMember({ name: "funcCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_funcCustomerId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "govCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_govCustomerId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "stateProgramId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_stateProgramId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "blockId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_blockId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "subBlockId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_subBlockId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dopEkId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_dopEkId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kcsrId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_kcsrId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "statusId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_statusId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "planTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_planTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "purchaseStartPlanDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitActivityVersion.prototype, "_purchaseStartPlanDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitActivityVersion.prototype, "_changeDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeUserFio", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityVersion.prototype, "_changeUserFio", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeNotice", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityVersion.prototype, "_changeNotice", void 0);
tslib_1.__decorate([
    jsonMember({ name: "budgetPeriod", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_budgetPeriod", void 0);
tslib_1.__decorate([
    jsonMember({ name: "workTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_workTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "totalAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_totalAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "firstPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_firstPeriodAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "secondPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_secondPeriodAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "thirdPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_thirdPeriodAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "totalRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_totalRegionalAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "firstPeriodRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_firstPeriodRegionalAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "secondPeriodRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_secondPeriodRegionalAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "thirdPeriodRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityVersion.prototype, "_thirdPeriodRegionalAmount", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitActivityFinancingAmount, { name: "financingAmount", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivityVersion.prototype, "_financingAmount", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitActivityFinancingAmountBySource, { name: "financingAmountBySources", emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivityVersion.prototype, "_financingAmountBySource", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitFinancingRedistribution, { name: "financingRedistribution", emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivityVersion.prototype, "_financingRedistribution", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitFinancingRedistributionLite, { name: "financingRedistributionLight", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array),
    tslib_1.__metadata("design:paramtypes", [])
], PitActivityVersion.prototype, "financingRedistributionLight", null);
tslib_1.__decorate([
    jsonArrayMember(PitActivityStateProgramIndicators, { name: "stateProgramIndicators", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivityVersion.prototype, "_stateProgramIndicators", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitFile, { emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivityVersion.prototype, "files", void 0);
PitActivityVersion = tslib_1.__decorate([
    jsonObject
], PitActivityVersion);
export { PitActivityVersion };
